<email-layout>
  <ng-container logo>
    <email-recruitee-logo />
  </ng-container>

  <ng-container header>
    <email-message-header [header]="data.title" />
  </ng-container>

  <ng-container body>
    <table>
      <tr>
        <td colspan="3">
          <email-text [contents]="data.rescheduled_by_html" />
          <email-margin [height]="16" />
          <email-infobox
            [contents]="data.rescheduled_reason_html"
            [wrapperTag]="'p'"
            [theme]="'info'"
          />
          <email-margin [height]="28" />
        </td>
      </tr>
      <!-- When -->
      <tr>
        <td class="event-notification-title-col">
          <email-text [contents]="data.when_label" color="light" />
        </td>
        <td>&nbsp;&nbsp;&nbsp;&nbsp;</td>
        <td width="100%">
          <email-text
            [color]="'success'"
            [contents]="data.updated_label"
            [bold]="true"
          />&nbsp;&nbsp;<email-text [contents]="data.starts_at_html" />
          <br />
          <email-text [contents]="data.starts_at_timezone" color="light" />

          <br />

          <email-text
            [color]="'disabled'"
            [contents]="data.former_label"
            [strikethrough]="true"
          />&nbsp;&nbsp;<email-text
            [color]="'disabled'"
            [strikethrough]="true"
            [contents]="data.old_starts_at_html"
          />
          <br />
          <email-text
            [color]="'disabled'"
            [strikethrough]="true"
            [contents]="data.old_starts_at_timezone"
          />
          <ng-container *mailgunIf="data.reschedule_link_url">
            <br />
            <email-text
              [contents]="data.reschedule_label"
              [size]="'small'"
              [color]="'light'"
            ></email-text
            >&nbsp;&nbsp;<email-link
              [href]="data.reschedule_link_url"
              [label]="data.reschedule_link"
              [textOpts]="{ bold: true, color: 'primary', size: 'small' }"
            />
          </ng-container>
        </td>
      </tr>
      <tr>
        <td colspan="3">
          <email-margin [height]="16" />
        </td>
      </tr>
      <!-- Interviewers -->
      <tr>
        <td class="event-notification-title-col">
          <email-text [contents]="data.interviewers_label" color="light" />
        </td>
        <td>&nbsp;&nbsp;&nbsp;&nbsp;</td>
        <td><email-text [contents]="data.interviewers" [bold]="true" /></td>
      </tr>
      <tr>
        <td colspan="3">
          <email-margin [height]="16" />
        </td>
      </tr>
      <!-- Candidate -->
      <ng-container *mailgunIf="data.candidate">
        <tr>
          <td class="event-notification-title-col">
            <email-text [contents]="data.candidate_label!" color="light" />
          </td>
          <td>&nbsp;&nbsp;&nbsp;&nbsp;</td>
          <td>
            <email-link
              [href]="data.candidate_url"
              [label]="data.candidate"
              [textOpts]="{ bold: true, color: 'primary' }"
            />
          </td>
        </tr>
        <tr>
          <td colspan="3">
            <email-margin [height]="16" />
          </td>
        </tr>
      </ng-container>

      <!-- Link -->
      <tr>
        <td class="event-notification-title-col">
          <email-text [contents]="data.event_label" color="light" />
        </td>
        <td>&nbsp;&nbsp;&nbsp;&nbsp;</td>
        <td>
          <email-link
            [href]="data.event_url"
            [label]="data.event_url"
            [textOpts]="{ bold: true, color: 'primary' }"
          />
        </td>
      </tr>

      <!-- Public note -->
      <ng-container *mailgunIf="data.public_note">
        <tr>
          <td colspan="3">
            <email-margin [height]="16" />
          </td>
        </tr>
        <tr>
          <td class="event-notification-title-col">
            <email-text [contents]="data.public_note_label" color="light" />
          </td>
          <td>&nbsp;&nbsp;&nbsp;&nbsp;</td>
          <td><email-text [contents]="data.public_note" /></td>
        </tr>
      </ng-container>

      <!-- Private note -->
      <ng-container *mailgunIf="data.private_note">
        <tr>
          <td colspan="3">
            <email-margin [height]="16" />
          </td>
        </tr>
        <tr>
          <td class="event-notification-title-col">
            <email-text [contents]="data.private_note_label" color="light" />
          </td>
          <td>&nbsp;&nbsp;&nbsp;&nbsp;</td>
          <td><email-text [contents]="data.private_note" /></td>
        </tr>
      </ng-container>
    </table>
  </ng-container>

  <ng-container footer>
    <email-text [contents]="data.footer" color="light" presetName="inline" size="small" />&nbsp;
  </ng-container>
</email-layout>
